import { createEffect } from 'effector'
import { attach } from 'effector/compat'
import { throttle } from 'lodash'

import { $creatorId } from '@/models/creators.ts'
import { sendToPusherChannel } from '@/modules/pusher/PusherProvider.tsx'

export const startTypingToFanFx = attach({
  name: 'send start typing event to pusher',
  source: { creatorId: $creatorId },
  mapParams: (fanId: number, { creatorId }) => ({
    userId: fanId,
    creatorId: creatorId!,
  }),
  effect: createEffect(
    ({ userId, creatorId }: { userId: number; creatorId: number }) => {
      return sendToPusherChannel(
        `private-chatting-ui-${creatorId}`,
        'client-typing',
        { userId },
      )
    },
  ),
})

export const startTypingDebounced = throttle(startTypingToFanFx, 3000)
